// DayX has one light appearance. These helpers keep every document, including
// the floating timer window, on that palette.
export function syncAppearanceDocument(target = document) {
  window.DayXAppearance.apply(target);
}

export function bindAppearance() {
  syncAppearanceDocument();
}
